import React from "react";
import { MessageSquare } from "lucide-react";

interface Chat8EmptyStateProps {
  title?: string;
  description?: string;
}

export const Chat8EmptyState: React.FC<Chat8EmptyStateProps> = ({
  title,
  description,
}) => {
  const displayTitle = title ?? "LicitarsAI";
  const displayDescription = description ?? "Selecione um documento na barra lateral para iniciar uma conversa inteligente com nosso assistente baseado em IA";

  return (
    <div className="flex flex-col items-center justify-center h-full bg-navy-800 p-8">
      <div className="max-w-md text-center space-y-6">
        <div className="w-24 h-24 mx-auto rounded-2xl gradient-primary-br flex items-center justify-center shadow-lg shadow-accent">
          <MessageSquare className="w-12 h-12 text-white" />
        </div>
        
        <div className="space-y-3">
          <h2 className="text-2xl font-bold text-platinum">
            {displayTitle}
          </h2>
          <p className="text-silver/80 text-base leading-relaxed">
            {displayDescription}
          </p>
        </div>
        
        <div className="glass-card p-4 rounded-lg border border-white/10">
          <p className="text-sm text-silver/70">
            💡 <span className="font-semibold">Dica:</span> O assistente pode responder 
            perguntas, gerar conteúdo e auxiliar na elaboração de documentos
          </p>
        </div>
      </div>
    </div>
  );
};
